import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { BudgetUpload } from './budget-upload.model';

export const uploadBudgets = createAction(
    '[BudgetUpload/API] POST UploadBudgets',
    props<{ JsonString: string }>()
);

export const loadBudgetUploads = createAction(
    '[BudgetUpload/API] Load BudgetUploads',
    props<{ BudgetUploads: BudgetUpload[] }>()
);

export const addBudgetUpload = createAction(
    '[BudgetUpload/API] Add BudgetUpload',
    props<{ BudgetUpload: BudgetUpload }>()
);

export const upsertBudgetUpload = createAction(
    '[BudgetUpload/API] Upsert BudgetUpload',
    props<{ BudgetUpload: BudgetUpload }>()
);

export const addBudgetUploads = createAction(
    '[BudgetUpload/API] Add BudgetUploads',
    props<{ BudgetUploads: BudgetUpload[] }>()
);

export const upsertBudgetUploads = createAction(
    '[BudgetUpload/API] Upsert BudgetUploads',
    props<{ BudgetUploads: BudgetUpload[] }>()
);

export const updateBudgetUpload = createAction(
    '[BudgetUpload/API] Update BudgetUpload',
    props<{ BudgetUpload: Update<BudgetUpload> }>()
);

export const updateBudgetUploads = createAction(
    '[BudgetUpload/API] Update BudgetUploads',
    props<{ BudgetUploads: Update<BudgetUpload>[] }>()
);

export const deleteBudgetUpload = createAction(
    '[BudgetUpload/API] Delete BudgetUpload',
    props<{ id: string }>()
);

export const deleteBudgetUploads = createAction(
    '[BudgetUpload/API] Delete BudgetUploads',
    props<{ ids: string[] }>()
);

export const clearBudgetUploads = createAction(
    '[BudgetUpload/API] Clear BudgetUploads'
);

export const updateBudgetUploadSuccess = createAction(
    '[BudgetUpload/API] Update BudgetUploads Success Event',
    props<{ BudgetUpload: Partial<BudgetUpload> }>()
);
